// Klaviyo Subscribe Form - Official API (Mobile-friendly)
function initKlaviyoForm() {
   const form = document.getElementById("klaviyo-subscribe-form");
   if (!form) return;

   form.addEventListener("submit", async function (e) {
      e.preventDefault();
      e.stopPropagation();

      const email = this.email.value.trim();
      const messageDiv = document.getElementById("klaviyo-message");
      const submitBtn = this.querySelector('button[type="submit"]');

      // Basic email validation
      if (!email || !email.includes("@")) {
         messageDiv.textContent = "Please enter a valid email address.";
         messageDiv.style.color = "var(--lsr-red)";
         return;
      }

      // Show loading state
      if (submitBtn) submitBtn.disabled = true;

      try {
         const response = await fetch(
            "https://a.klaviyo.com/client/subscriptions?company_id=VzkEe9",
            {
               method: "POST",
               headers: {
                  Accept: "application/vnd.api+json",
                  "Content-Type": "application/vnd.api+json",
                  revision: "2025-07-15",
               },
               body: JSON.stringify({
                  data: {
                     type: "subscription",
                     attributes: {
                        profile: {
                           data: {
                              type: "profile",
                              attributes: {
                                 email: email,
                              },
                           },
                        },
                        custom_source: "Website signup",
                     },
                     relationships: {
                        list: {
                           data: {
                              type: "list",
                              id: "UpSyHz", // Replace with your actual List ID
                           },
                        },
                     },
                  },
               }),
            }
         );

         if (response.ok || response.status === 202) {
            messageDiv.textContent = "Thank you for subscribing!";
            messageDiv.style.color = "var(--lsr-brn)";
            this.reset();
         } else {
            const errorData = await response.json();
            console.error("Klaviyo error:", errorData);
            messageDiv.textContent = "There was an error. Please try again.";
            messageDiv.style.color = "var(--lsr-red)";
         }
      } catch (error) {
         console.error("Network error:", error);
         messageDiv.textContent = "There was an error.";
         messageDiv.style.color = "var(--lsr-red)";
      } finally {
         // Re-enable submit button
         if (submitBtn) submitBtn.disabled = false;
      }
   });
}

// Initialize on multiple events for better mobile compatibility
if (document.readyState === "loading") {
   document.addEventListener("DOMContentLoaded", initKlaviyoForm);
} else {
   initKlaviyoForm();
}

// Fallback for mobile devices
window.addEventListener("load", function () {
   setTimeout(initKlaviyoForm, 100);
});
